import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect,useState } from 'react';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/clientscities';

    const paths = {
        endpointSave: `${endpointBackend}governanceroom/clientscities/saveindicators`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/governanceroom/clientscitiesindicators/list`,
        pathView: `/governanceroom/clientscitiesindicators/view`
    }

    const labels = {
        labelTitleAdd: "Novo Indicador de Município",
        labelTitleEdit: "Editar Indicador de Município",
        labelTitleView: 'Visualizar Indicador de Município'
    }

    const hiddenValues = {}

    if (profileFilter.core_application_instance_id) {
        hiddenValues.core_application_instance_id = profileFilter.core_application_instance_id
    }

    const getForm = (values) => {

        let form = {
            hiddenValues: hiddenValues,
            fields: [
                {
                    name: 'governance_room_client_city_id',
                    type: 'select',
                    label: 'Município',
                    readOnly: true,
                    options: [],
                    optionsEndpoint: {
                      endpoint: endpointBackend + 'governanceroom/clientscities/getall',
                      label: 'company_name',
                      value: 'id',
                      params: {
                        filter: {
                            ...hiddenValues
                        }
                      }
                    },
                    validations: {
                      required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'indicators',
                    type: 'multiinput',
                    label: 'Indicadores',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Nome',
                            type: 'text',
                            name: 'indicator_name',
                            validations: {
                                required: true
                            },
                            maxLength: 500
                        },
                        {
                            label: 'Link',
                            type: 'text',
                            name: 'indicator_link',
                            validations: {
                                required: true
                            },
                            maxLength: 500
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }   
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById,{id:id})
            }
            if(profileFilter.core_application_instance_id){
                values.core_application_instance_id = profileFilter.core_application_instance_id;
            }
            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    },[])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
